<template>
    <div class="p-6 bg-gray-100 min-h-screen flex flex-col items-center justify-center">
      <div class="max-w-lg w-full">
        <!-- Caso sin token_final -->
        <div v-if="!existFinal" class="bg-gray-300 p-6 rounded shadow mb-6 text-center">
          <h2 class="text-xl font-bold mb-4">Procesando tu imagen</h2>
          <!-- Cuadro interno con imagen y mensaje -->
          <div class="bg-white p-4 rounded shadow mb-4">
            <img src="../../assets/logohp.png" alt="Procesando" class=" mx-auto mb-4" />
            <p class="text-gray-700">Tu resultado aún no está listo, pero podrás verlo aquí más tarde.</p>
          </div>
          <p class="text-gray-800 font-semibold mb-4">
            Comparte tu resultado para revisarlo más tarde o compartirlo con quien gustes.
            </p>
            <!-- Botón para compartir -->
            <button
            @click="compartirEnlace"
            class="bg-blue-500 mx-auto text-white p-4 rounded-full shadow hover:bg-blue-600 flex items-center justify-center">
            <i class="fas fa-share-alt mr-2"></i> Compartir
            </button>
        </div>
  
        <!-- Redirección si token_final existe -->
        <div v-else></div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from "vue";
  import { useRouter, useRoute } from "vue-router";
  import axios from "axios";
  
  export default {
    setup() {
      const router = useRouter();
      const route = useRoute();
  
      const token = ref("");
      const existFinal = ref(false);
  
      const consultarPendiente = async () => {
        try {
          const { data } = await axios.post("/api/consultando-pendiente", {
            token: token.value,
          });
  
          if (data.exist_final) {
            router.push(`/check-result/${data.token_final}`);
          } else {
            existFinal.value = false;
          }
        } catch (error) {
          console.error("Error al consultar el token pendiente:", error);
          alert("Ocurrió un error al procesar el token.");
        }
      };
  
      const compartirEnlace = () => {
        if (navigator.share) {
          navigator
            .share({
              title: "Consulta tu token pendiente",
              text: "Revisa tu resultado aquí:",
              url: window.location.href,
            })
            .then(() => console.log("Enlace compartido"))
            .catch((error) => console.error("Error al compartir:", error));
        } else {
          alert("Tu navegador no soporta la función de compartir.");
        }
      };
  
      onMounted(() => {
        token.value = route.params.token;
        consultarPendiente();
      });
  
      return { existFinal, compartirEnlace };
    },
  };
  </script>
  
  <style scoped>
  .loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 2s linear infinite;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  </style>
  